import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Auth lives in httpOnly cookies set by the backend; nothing sensitive is kept in browser storage.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");

export const promptImg = (p) => p.sample_image || fileUrl(p.sample_path);

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export async function downloadImage(path, name = "cutie-parlor.png") {
  const res = await fetch(fileUrl(path), { credentials: "include" });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
